import React from 'react';
import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import CardCustom from './CardCustom'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
}));

export default function GridCardList(props) {
    const classes = useStyles();
    const vagas = props.vagasPaginadas

    return (
        <div>
            <Container component="main" maxWidth="xl">
                <div className={classes.paper}>
                    <Grid container spacing={3}>
                        {vagas.map((vaga, index) => (
                            <Grid item xs={12} sm={6} md={4} key={`${vaga.title}${index}`}>
                                <CardCustom
                                    vaga={vaga}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </Container>
        </div>
    );
}
